import i18next from "i18next";

export const CmdAuthor = "CmdAuthor";
export const CmdMyPub = "CmdMyPub";
export const CmdTopic = "CmdTopic";
export const CmdSecondTopic = "CmdSecondTopic";
export const CmdIncludeSubtopics = "CmdIncludeSubtopics";
export const CmdTopicNoSubs = "CmdTopicAndSubtopic";
export const CmdUser = "CmdUser";
export const CmdGroup = "CmdGroup";

export const CmdPublishStartDate = "CmdStartDate";
export const CmdPublishEndDate = "CmdEndDate";
export const CmdAvailableStartDate = "CmdAvailableStartDate";
export const CmdAvailableEndDate = "CmdAvailableEndDate";
export const CmdCreateStartDate = "CmdCreateStartDate";
export const CmdCreateEndDate = "CmdCreateEndDate";
export const CmdPublicationHighlighted = "CmdPublicationHighlighted";
export const CmdPublicationExpired = "CmdPublicationExpired";
export const CmdPublicationFuture = "CmdPublicationFuture";

export const CmdFromDate = "CmdFromDate";
export const CmdToDate = "CmdToDate";

export const CmdWithVideoOnly = "CmdVideoOnly";
export const CmdWithVideo = "CmdVideo";
export const CmdWithImage = "CmdImage";
export const CmdWithFile = "CmdFile";

export const CmdWithLikes = "CmdWithLikes";
export const CmdWithThanks = "CmdWithThanks";
export const CmdWithComments = "CmdWithComments";
export const CmdWithAward = "Award";
export const CmdWithNewLikes = "CmdWithNewLikes";
export const CmdWithNewThanks = "CmdWithNewThanks";
export const CmdWithNewComments = "CmdWithNewComments";

export const CmdWithApprovals = "CmdWithApprovals";
export const CmdWithoutApprovals = "CmdWithoutApprovals";
export const CmdDescription = "CmdDescription";
export const CmdTopicPublic = "CmdTopicPublic";
export const CmdTopicPrivate = "CmdTopicPrivate";

export const CmdWithoutAward = "CmdWithoutAward";
export const CmdWithAutoEnroll = "CmdWithAutoEnroll";
export const CmdWithoutAutoEnroll = "CmdWithoutAutoEnroll";

export const CmdCourseNotStarted = "CmdCourseNotStarted";
export const CmdCourseExpiring = "CmdCourseExpiring";
export const CmdCourseExpired = "CmdCourseExpired";
export const CmdCourseItemDeleted = "CmdCourseItemDeleted";

export const CmdPost = "CmdPost";
export const CmdQuestion = "CmdQuestion";
export const CmdList = "CmdList";
export const CmdCourse = "CmdCourse";
export const CmdPoll = "CmdPoll";
export const CmdSurvey = "CmdSurvey";

export const CmdWithNegativeLikes = "CmdWithNegativeLikes";
export const CmdWithDenoncement = "CmdWithDenoncement";
export const CmdWithOpenDenoncement = "CmdWithOpenDenoncement";
export const CmdMention = "CmdMention";

export const CmdQuestionWithAnswers = "CmdQuestionWithAnswers";
export const CmdQuestionWithoutAnswers = "CmdQuestionWithoutAnswers";

export const CmdInstitutional = "CmdInstitutional";
export const CmdOnlyInstitutional = "CmdOnlyInstitutional";
export const CmdOnlyNotInstitutional = "CmdOnlyNotInstitutional";
export const CmdOnlyBlocked = "CmdOnlyBlocked";
export const CmdDeleted = "CmdDeleted";

export const CmdTitle = "CmdTitle";
export const CmdSpectator = "CmdSpectator";
export const CmdActiveOnly = "CmdActiveOnly";
export const CmdIsActive = "CmdIsActive";
export const CmdIsInactive = "CmdIsInactive";

export const CmdDeepTeam = "CmdDeepTeam";

export const CmdAccountDelete = "CmdAccountDelete";
export const CmdAccountBlocked = "CmdAccountBlocked";
export const CmdAccountNotBlocked = "CmdAccountNotBlocked";
export const CmdAccountLockedOut = "CmdAccountLockedOut";
export const CmdAccountBlockCode = "CmdAccountBlockCode ";
export const CmdRoles = "CmdRoles";
export const CmdIsManager = "CmdIsManager";
export const CmdWithManager = "CmdWithManager";
export const CmdSpecialty = "CmdSpecialty";
export const CmdKnowAbout = "CmdKnowAbout";
export const CmdLocation = "CmdLocation";
export const CmdLocationName = "CmdLocationName";
export const CmdLastAccessDateStart = "CmdLastAccessDateStart";
export const CmdLastAccessDateEnd = "CmdLastAccessDateEnd";

export const CmdKTLevel0 = "CmdKTLevel0";
export const CmdKTLevel1 = "CmdKTLevel1";
export const CmdKTLevel2 = "CmdKTLevel2";
export const CmdKTLevel3 = "CmdKTLevel3";
export const CmdKTLevel4 = "CmdKTLevel4";
export const CmdKTImportance1 = "CmdKTImportance1";
export const CmdKTImportance2 = "CmdKTImportance2";
export const CmdKTImportance3 = "CmdKTImportance3";
export const CmdKTBlocked = "CmdKTBlocked";

export const CmdMediaProcessingDone = "CmdMediaProcessingDone";
export const CmdMediaProcessingCreating = "CmdMediaProcessingCreating";
export const CmdMediaProcessingWaiting = "CmdMediaProcessingWaiting";
export const CmdMediaProcessingFailed = "CmdMediaProcessingFailed";
export const CmdMediaProcessingDeleted = "CmdMediaProcessingDeleted";

export const CmdQueuePending = "CmdQueuePending";
export const CmdQueueDone = "CmdQueueDone";
export const CmdQueueFailed = "CmdQueueFailed";
export const CmdQueueMailOnly = "CmdQueueMailOnly";
export const CmdQueueCloudOnly = "CmdQueueCloudOnly";

export const CmdJobRunning = "CmdJobRunning";
export const CmdJobEnqueued = "CmdJobEnqueued";
export const CmdJobFinishedSuccessfully = "CmdJobFinishedSuccessfully";
export const CmdJobFinishedWithError = "CmdJobFinishedWithError";
export const CmdJobCanceled = "CmdJobCanceled";

export const CmdPublicationApprovedOnly = "CmdPublicationApprovedOnly";
export const CmdPublicationPendingOnly = "CmdPublicationPendingOnly";
export const CmdPublicationRejectedOnly = "CmdPublicationRejectOnly";

export function CommandLabels() {
    var r = {};
    r[CmdAuthor] = i18next.t("Common.Filter.Command.Author");
    r[CmdMyPub] = i18next.t("Common.Filter.Command.MyPub");
    r[CmdTopic] = i18next.t("Common.Filter.Command.Topic");
    r[CmdSecondTopic] = i18next.t("Common.Filter.Command.SecondTopic");
    r[CmdUser] = i18next.t("Common.Filter.Command.User");
    r[CmdGroup] = i18next.t("Common.Filter.Command.Group");
    r[CmdIncludeSubtopics] = i18next.t("Common.Filter.Command.IncludeSubtopics");
    r[CmdTopicNoSubs] = i18next.t("Common.Filter.Command.TopicNoSubs");

    r[CmdFromDate] = i18next.t("Common.Filter.Command.FromDate");
    r[CmdToDate] = i18next.t("Common.Filter.Command.ToDate");

    r[CmdCourseNotStarted] = i18next.t("Common.Filter.Command.CourseNotStarted");
    r[CmdCourseExpiring] = i18next.t("Common.Filter.Command.CourseExpiring");
    r[CmdCourseExpired] = i18next.t("Common.Filter.Command.CourseExpired");
    r[CmdCourseItemDeleted] = i18next.t("Common.Filter.Command.CourseItemDeleted");

    r[CmdPublishStartDate] = i18next.t("Common.Filter.Command.PublishStartDate");
    r[CmdPublishEndDate] = i18next.t("Common.Filter.Command.PublishEndDate");
    r[CmdAvailableStartDate] = i18next.t("Common.Filter.Command.AvailableStartDate");
    r[CmdAvailableEndDate] = i18next.t("Common.Filter.Command.AvailableEndDate");
    r[CmdAvailableStartDate] = i18next.t("Common.Filter.Command.AvailableStartDate");
    r[CmdAvailableEndDate] = i18next.t("Common.Filter.Command.AvailableEndDate");
    r[CmdCreateStartDate] = i18next.t("Common.Filter.Command.CreateStartDate");
    r[CmdCreateEndDate] = i18next.t("Common.Filter.Command.CreateEndDate");
    r[CmdPublicationExpired] = i18next.t("Common.Filter.Command.PublicationExpired");
    r[CmdPublicationFuture] = i18next.t("Common.Filter.Command.PublicationFuture");
    r[CmdPublicationHighlighted] = i18next.t("Common.Filter.Command.PublicationHighlighted");

    r[CmdWithVideoOnly] = i18next.t("Common.Filter.Command.WithVideoOnly");
    r[CmdWithVideo] = i18next.t("Common.Filter.Command.WithVideo");
    r[CmdWithImage] = i18next.t("Common.Filter.Command.WithImage");
    r[CmdWithFile] = i18next.t("Common.Filter.Command.WithFile");
    r[CmdWithAutoEnroll] = i18next.t("Common.Filter.Command.WithAutoEnroll");
    r[CmdWithAward] = i18next.t("Common.Filter.Command.WithAward");
    r[CmdWithComments] = i18next.t("Common.Filter.Command.WithComments");
    r[CmdWithLikes] = i18next.t("Common.Filter.Command.WithLikes");
    r[CmdWithThanks] = i18next.t("Common.Filter.Command.WithThanks");
    r[CmdWithNewLikes] = i18next.t("Common.Filter.Command.WithNewLikes");
    r[CmdWithNewThanks] = i18next.t("Common.Filter.Command.WithNewThanks");
    r[CmdWithNewComments] = i18next.t("Common.Filter.Command.WithNewComments");
    r[CmdWithoutAutoEnroll] = i18next.t("Common.Filter.Command.WithoutAutoEnroll");
    r[CmdWithoutAward] = i18next.t("Common.Filter.Command.WithoutAward");

    r[CmdWithApprovals] == i18next.t("Common.Filter.Command.WithApprovals");
    r[CmdWithoutApprovals] = i18next.t("Common.Filter.Command.WithoutApprovals");
    r[CmdDescription] = i18next.t("Common.Filter.Command.Description");
    r[CmdTopicPublic] = i18next.t("Common.Filter.Command.TopicPublic");
    r[CmdTopicPrivate] = i18next.t("Common.Filter.Command.TopicPrivate");

    r[CmdPost] = i18next.t("Common.Filter.Command.Post");
    r[CmdQuestion] = i18next.t("Common.Filter.Command.Question");
    r[CmdList] = i18next.t("Common.Filter.Command.List");
    r[CmdCourse] = i18next.t("Common.Filter.Command.Course");
    r[CmdPoll] = i18next.t("Common.Filter.Command.Poll");

    r[CmdWithNegativeLikes] = i18next.t("Common.Filter.Command.WithNegativeLikes");
    r[CmdWithDenoncement] = i18next.t("Common.Filter.Command.WithDenoncement");
    r[CmdWithOpenDenoncement] = i18next.t("Common.Filter.Command.WithOpenDenoncement");
    r[CmdMention] = i18next.t("Common.Filter.Command.Mention");
    r[CmdQuestionWithAnswers] = i18next.t("Common.Filter.Command.QuestionWithAnswers");
    r[CmdQuestionWithoutAnswers] = i18next.t("Common.Filter.Command.QuestionWithoutAnswers");
    r[CmdOnlyBlocked] = i18next.t("Common.Filter.Command.OnlyBlocked");
    r[CmdDeleted] = i18next.t("Common.Filter.Command.Deleted");

    r[CmdInstitutional] = i18next.t("Common.Filter.Command.Institutional");
    r[CmdOnlyInstitutional] = i18next.t("Common.Filter.Command.OnlyInstitutional");
    r[CmdOnlyNotInstitutional] = i18next.t("Common.Filter.Command.OnlyNotInstitutional");

    r[CmdTitle] = i18next.t("Common.Filter.Command.Title");
    r[CmdSpectator] = i18next.t("Common.Filter.Command.Spectator");
    r[CmdActiveOnly] = i18next.t("Common.Filter.Command.ActiveOnly");
    r[CmdIsActive] = i18next.t("Common.Filter.Command.IsActive");
    r[CmdIsInactive] = i18next.t("Common.Filter.Command.IsInactive");
    r[CmdDeepTeam] = i18next.t("Common.Filter.Command.DeepTeam");

    r[CmdAccountBlocked] = i18next.t("Common.Filter.Command.AccountBlocked");
    r[CmdAccountNotBlocked] = i18next.t("Common.Filter.Command.AccountNotBlocked");
    r[CmdAccountBlockCode] = i18next.t("Common.Filter.Command.AccountBlockCode");
    r[CmdAccountLockedOut] = i18next.t("Common.Filter.Command.AccountLockedOut");
    r[CmdAccountDelete] = i18next.t("Common.Filter.Command.AccountDelete");
    r[CmdRoles] = i18next.t("Common.Filter.Command.Roles");

    r[CmdIsManager] = i18next.t("Common.Filter.Command.IsManager");
    r[CmdWithManager] = i18next.t("Common.Filter.Command.WithManager");

    r[CmdLocation] = i18next.t("Common.Filter.Command.Location");
    r[CmdLocationName] = i18next.t("Common.Filter.Command.LocationName");

    r[CmdSpecialty] = i18next.t("Common.Filter.Command.Specialty");
    r[CmdKnowAbout] = i18next.t("Common.Filter.Command.KnowAbout");

    r[CmdLastAccessDateStart] = i18next.t("Common.Filter.Command.LastAccessDateStart");
    r[CmdLastAccessDateEnd] = i18next.t("Common.Filter.Command.LastAccessDateEnd");

    r[CmdKTLevel0] = i18next.t("Common.Filter.Command.KTLevel0");
    r[CmdKTLevel1] = i18next.t("Common.Filter.Command.KTLevel1");
    r[CmdKTLevel2] = i18next.t("Common.Filter.Command.KTLevel2");
    r[CmdKTLevel3] = i18next.t("Common.Filter.Command.KTLevel3");
    r[CmdKTLevel4] = i18next.t("Common.Filter.Command.KTLevel4");

    r[CmdKTImportance1] = i18next.t("Common.Filter.Command.KTImportance1");
    r[CmdKTImportance2] = i18next.t("Common.Filter.Command.KTImportance2");
    r[CmdKTImportance3] = i18next.t("Common.Filter.Command.KTImportance3");

    r[CmdKTBlocked] = i18next.t("Common.Filter.Command.KTBlocked");

    r[CmdMediaProcessingDone] = i18next.t("Common.Filter.Command.MediaProcessingDone");
    r[CmdMediaProcessingCreating] = i18next.t("Common.Filter.Command.MediaProcessingCreating");
    r[CmdMediaProcessingWaiting] = i18next.t("Common.Filter.Command.MediaProcessingWaiting");
    r[CmdMediaProcessingFailed] = i18next.t("Common.Filter.Command.MediaProcessingFailed");
    r[CmdMediaProcessingDeleted] = i18next.t("Common.Filter.Command.MediaProcessingDeleted");

    r[CmdQueuePending] = i18next.t("Common.Filter.Command.QueuePending");
    r[CmdQueueDone] = i18next.t("Common.Filter.Command.QueueDone");
    r[CmdQueueFailed] = i18next.t("Common.Filter.Command.QueueFailed");
    r[CmdQueueMailOnly] = i18next.t("Common.Filter.Command.QueueMailOnly");
    r[CmdQueueCloudOnly] = i18next.t("Common.Filter.Command.QueueCloudOnly");

    r[CmdJobRunning] = i18next.t("Common.Filter.Command.JobRunning");
    r[CmdJobEnqueued] = i18next.t("Common.Filter.Command.JobEnqueued");
    r[CmdJobFinishedSuccessfully] = i18next.t("Common.Filter.Command.JobFinishedSuccessfully");
    r[CmdJobFinishedWithError] = i18next.t("Common.Filter.Command.JobFinishedWithError");
    r[CmdJobCanceled] = i18next.t("Common.Filter.Command.JobCanceled");

    r[CmdPublicationApprovedOnly] = i18next.t("Common.Filter.Command.PublicationApprovedOnly");
    r[CmdPublicationPendingOnly] = i18next.t("Common.Filter.Command.PublicationPendingOnly");
    r[CmdPublicationRejectedOnly] = i18next.t("Common.Filter.Command.PublicationRejectedOnly");
    return r;
};
